define('gameday-index-enums/enums/events/SponsorshipEvents',{
	refreshPageAds: "GameDayIndex::refreshPageAds",
	refreshAdImage: "GameDayIndex::refreshAdImage",
	displayInsterstitalRoadblock: "GameDayIndex::displayInsterstitalRoadblock",
	updateChyronAds: "updateChyronAds"
});
